import { findTableFromPos } from 'common/Prose/utils/table'
import { TableMap } from 'common/Prose/utils/table/TableMap'
import { schema } from 'prose-core'
import { Node as ProsemirrorNode } from 'prosemirror-model'

export const rowIsHeaderCells = (posOfTable: number, rowIdx: number, doc: ProsemirrorNode): boolean => {
  const table = findTableFromPos(posOfTable + 1, doc)
  if (!table) return false
  const tableMap = new TableMap({ posBeforeTable: table.pos, node: table.node })
  const cellsInRow = tableMap.getOrderedPosListInRow(rowIdx).map((pos) => doc.nodeAt(pos))
  return cellsInRow.every((cell) => cell && cell.type === schema.nodes.table_header)
}
